import * as Sentry from '@sentry/browser';
import { Scope } from '@sentry/browser';
export const setSentryPageContext = (context: any) => {};

export const applySentryFetchMiddleware = () => {};
export const iFixitAPIRequestHeaderName = 'X-iFixit-API-Request';
export type SentryDetails = Exclude<Parameters<Scope['update']>[0], undefined>;

export class SentryError extends Error {
   constructor(
      message: string,
      readonly sentryDetails: SentryDetails = {}
   ) {
      super(message);
   }
}
export function injectSentryErrorHandler() {
   Sentry.addGlobalEventProcessor((event, hint) => {
      const exception = hint.originalException;

      if (exception instanceof SentryError) {
         const currentScope = Sentry.getCurrentHub().getScope();
         const newScope = Scope.clone(currentScope);

         newScope.update(exception.sentryDetails);
         newScope.applyToEvent(event, hint);
      }

      return event;
   });
}

export function captureException(e: any, sentryDetails: SentryDetails) {
   Sentry.captureException(e, sentryDetails);
}
